import { render, staticRenderFns } from "./ProcessingPersonnelModal.vue?vue&type=template&id=cd0c6050"
import script from "./ProcessingPersonnelModal.vue?vue&type=script&lang=js"
export * from "./ProcessingPersonnelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports